import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { AppConstants } from "../../constants/app-constants";
import { BehaviorSubject, Observable, Subject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class OnboardService {

    constructor(private http: HttpClient) {

    }


    // Observable - Preloaded Data  
    private discardData = new Subject<any>();
    discardDatastring$ = this.discardData.asObservable();

    // Observable - isDownloadAllFiles comments  
    private isDownloadAllFiles = new Subject<any>();
    isDownloadstring$ = this.isDownloadAllFiles.asObservable();

    discardDatafilter(filterby: any) {
        this.discardData.next(filterby);
    }

    getpreloadDatafilter(): Observable<any> {
        return this.discardData.asObservable();
    }
    isDownloadAllFilesTrigger(isDownloaded) {
        this.isDownloadAllFiles.next(isDownloaded);
    }
    // Written by Hari 
    archieveDownload(foldername) {
        const url = environment.SERVER_URL + AppConstants.BULKDOWNLOADFROMARCHIEVE;
        return this.http.get(url, {
            params: {
                foldername: foldername
            },
        });
    }

    uploadCompensationfiles(onboardfiles) {
        const url = environment.SERVER_URL + AppConstants.ONBOARD_SAVE_COMPENSATION_FILES;
        return this.http.put(url, onboardfiles);
    }


    uploadEduExpFiles(onboardfiles) {
        const url = environment.SERVER_URL + AppConstants.ONBOARDSAVEEDUCATIONEXPFILES;
        const headers = new Headers();
        const body = new FormData();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.put(url, onboardfiles);
    }
    uploadpreloadFormFiles(onboardfiles) {
        const url = environment.SERVER_URL + AppConstants.ONBOARDSAVEPRELOADFORMS;
        const headers = new Headers();
        const body = new FormData();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.put(url, onboardfiles);
    }

     uploadidentityFiles(onboardfiles, photo) {

        const url = environment.SERVER_URL + AppConstants.ONBOARDSAVEIDATTACHMENTFILES;
        const body = new FormData();
        if (photo != 'delete') {
            body.append('photograph', photo);
        }
        else {
            body.append('photographdelete', photo);
        }
        //PAN Card
        if (onboardfiles.idAttachmentsOnboard.pancardBytes != "delete") {
            if (onboardfiles.idAttachmentsOnboard.pancardTemploc != null && onboardfiles.idAttachmentsOnboard.pancardTemploc != "") {
                body.append('convertedtmpfilelocpan', onboardfiles.idAttachmentsOnboard.pancardTemploc);
            }
            else {
                body.append('pan', onboardfiles.idAttachmentsOnboard.pancardMultipart);

            }
        }
        else {
            body.append('pandelete', "delete");
        }
        //SSN
        if (onboardfiles.idAttachmentsOnboard.ssnBytes != "delete") {
            if (onboardfiles.idAttachmentsOnboard.ssnTemploc != null && onboardfiles.idAttachmentsOnboard.ssnTemploc != "") {
                body.append('convertedtmpfilelocssn', onboardfiles.idAttachmentsOnboard.ssnTemploc);
            }
            else {
                body.append('ssn', onboardfiles.idAttachmentsOnboard.ssnMultipart);
            }
        }
        else {
            body.append('ssndelete', "delete");
        }
        if (onboardfiles.idAttachmentsOnboard.passportBytes != "delete") {
            if (onboardfiles.idAttachmentsOnboard.passportTemploc != null && onboardfiles.idAttachmentsOnboard.passportTemploc != "") {
                body.append('convertedtmpfilelocpassport', onboardfiles.idAttachmentsOnboard.passportTemploc);
            }
            else {
                body.append('passport', onboardfiles.idAttachmentsOnboard.passportMultipart);
            }

        }
        else {
            body.append('passportdelete', "delete");
        }


        delete onboardfiles.idAttachmentsOnboard['pancardMultipart']
        delete onboardfiles.idAttachmentsOnboard['pancardTemploc']
        delete onboardfiles.idAttachmentsOnboard['pancardBytes']
        delete onboardfiles.idAttachmentsOnboard['ssnMultipart']
        delete onboardfiles.idAttachmentsOnboard['ssnTemploc']
        delete onboardfiles.idAttachmentsOnboard['ssnBytes']
        delete onboardfiles.idAttachmentsOnboard['passportMultipart']
        delete onboardfiles.idAttachmentsOnboard['passportTemploc']
        delete onboardfiles.idAttachmentsOnboard['passportBytes']
        delete onboardfiles.idAttachmentsOnboard['photographBytes']


        body.append('onboardFiles', JSON.stringify(onboardfiles));

        return this.http.put(url, body);
    }

    // gets the candidate by taking in id and orgid
    getOnboardData(id, orgid) {
        const url = environment.SERVER_URL + AppConstants.ONBOARD_GET_SNAPSHOT_BY_ID;
        return this.http.get(url, {
            params: {
                id: id,
                orgid: orgid,
            }
        });
    }

    // gets the candidate by taking in id and orgid
    onboardgetById() {
        const url = environment.SERVER_URL + AppConstants.GET_ONBOARD_DATA;
        return this.http.get(url);
    }

    // gets the candidate by taking in id and orgid
    onboardGetSnapshotById() {
        const url = environment.SERVER_URL + AppConstants.GET_ONBOARD_DATA;
        return this.http.get(url);
    }

    // submit onboard
    submitOnboard(data) {
        const url = environment.SERVER_URL + AppConstants.UPDATE_ONBOARD_DATA;
        return this.http.put(url, data);
    }

    checkIfFilesUploadedorNot(candidateid, orgid, filestobedownloaded, module, username, reqid, isrecruitmentmanager) {
        const url = environment.SERVER_URL + AppConstants.ONBOARDGETIFFILESUPLOADED;
        return this.http.get(url, {
            params: {
                candidateid: candidateid,
                orgid: orgid,
                filestodownload: filestobedownloaded,
                module: module,
                username: username,
                // reqid: reqid,
                isrecruitmentmanager: isrecruitmentmanager,

            }
        });
    }


    onboardboardFileDownload(element) {
        const url = environment.SERVER_URL + AppConstants.ONBOARDFILEDOWNLOAD;
        const headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http
            .put(url, element)
    }


    onboardboardZipFileDownload(element) {
        const url = environment.SERVER_URL + AppConstants.ZIPDOWNLOAD;
        const headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http
            .get(url, {
                params: element
            })
    }
}